import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getClientPortalTechnicianData } from '../../../services/config';
import { ITechnicianData } from '../../../services/config/types';

export const ThunkGetClientPortalTechnicianData = createAsyncThunk<ITechnicianData>(
  `${storeResources.CONFIG}/getClientPortalTechnicianData`,
  () => getClientPortalTechnicianData().then(res => res.data),
);
